import React from 'react'
import { usePageTracking } from '@/hooks/usePageTracking'

interface AnalyticsProviderProps {
    children: React.ReactNode
}

/**
 * Analytics provider component that handles page tracking
 * This should be placed high in the component tree to track all navigation
 */
export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
    // Initialize page tracking
    usePageTracking()

    return <>{children}</>
}

export default AnalyticsProvider
